import React, { useEffect, useState } from 'react'
import { FaBars } from "react-icons/fa";
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../Redux/loginUserSlice'
import Swal from 'sweetalert2'

const Navbar = () => {
  const [sidebar, setSideBar] = useState(false)

  const BASE_URl = window.location.origin

    const [bar, setBar] = useState(false)
    const mediaQuery = window.matchMedia('(max-width: 576px)')
    const dispatch = useDispatch()
    const user = useSelector((state) => state.loginUser.user);
    
    useEffect(()=>{
        const changeBar = () => {
            if(mediaQuery.matches === false) {
                setBar(false)

            }
        } 
        mediaQuery.addEventListener('change', changeBar)
    }, [mediaQuery])
    
    const handleLgout = async() => {

      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do You Want To Logout",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Logout",
      });

      if(result.isConfirmed){
        fetch(`${BASE_URl}/api/logout`,{
          method: "GET",
          credentials: 'include'
        })
        .then((res) => res.json())
        .then((data) => {
          if(data&&data.sucess === true){
            dispatch(logoutUser())
            toast.success(data.messege)
            setTimeout(()=>{
              window.location.reload()
            },500)
          } else if(data&&data.sucess === false){
            toast.error(data.messege)
          }
        })
        .catch((error) => {
          if(error){
            toast.error(error.messege || 'Internal Server Error')
          }
        })
      }
    }


  return (
    <div>
      <nav className='flex justify-between items-center text-white bg-black h-14 w-[100%]'>
        <div className='ml-3.5 font-bold text-xl text-yellow-400 font-sans flex gap-4 items-center'>
        {user&&user.role === 'Admin'?<div>
          <span className='text-2xl cursor-pointer' onClick={()=>{setSideBar(!sidebar)}}><FaBars/></span>
        </div>:null}
           <div>Food Delivery</div>
        </div>
        <div className='hidden sm:flex justify-evenly items-center w-[50%] mr-9'>
        <Link to={'/'}>Home</Link>
        {user?<Link to="/vieworders" onClick={()=>{setBar(!bar)}}>View Orders</Link>:null}
        {user?null:<><Link to={'/auth/singup'}>Sing Up</Link>
        <Link to={'/auth/login'}>Login</Link></>}
        {user?<button className='bg-amber-200 p-2 font-bold font-mono cursor-pointer text-black rounded-xl' onClick={handleLgout}>Logout</button>:null}
        </div>

        <div className='sm:hidden text-white mr-11 cursor-pointer text-2xl' onClick={()=>{setBar(!bar)}}>
            <FaBars/>
        </div>
      </nav>
      {bar?<nav className='h-[90vh] bg-black flex items-start justify-center w-[100%] sm:hidden'>
        <div className='text-white flex flex-col justify-evenly h-[70%]'>
            <Link to="/" onClick={()=>{setBar(!bar)}}>Home</Link>
            {user?<Link to="/vieworders" onClick={()=>{setBar(!bar)}}>View Orders</Link>:null}
            {user?null:<><Link to="/auth/login" onClick={()=>{setBar(!bar)}}>Login</Link>
            <Link to="/auth/singUp" onClick={()=>{setBar(!bar)}}>Sing Up</Link></>}
            {user?<button className='bg-amber-200 p-2 font-bold font-mono cursor-pointer text-black rounded-xl' onClick={()=>{
              handleLgout()
              setBar(!bar)}}>Logout</button>:null}
        </div>
      </nav>:null}

      {user&&user.role === 'Admin'?<>
     {sidebar?<div id='adminSidebar' className='w-40 h-[83vh] bg-black border-t-2 border-r-2 border-white text-amber-50 '>
      <div className='flex flex-col gap-7 items-center mt-14'>
      <Link to={'/admin/orders'} onClick={()=>{setSideBar(!sidebar)}}>Orders</Link>
      <Link to={'/admin'} onClick={()=>{setSideBar(!sidebar)}}>Header</Link>
      <Link to={'/admin/users'} onClick={()=>{setSideBar(!sidebar)}}>Users</Link>
      <Link onClick={()=>{setSideBar(!sidebar)}} to={'/admin/foods'}>Foods</Link>
      </div>
     </div>:null}</>:null}
    </div>
  )
}

export default Navbar
